<i class="material-icons" id = "asc" style="margin-top: 11px" *ngIf="sortDirection === 'asc'" >arrow_drop_up</i>
<i class="material-icons" id = "desc"  style="margin-top: 11px" *ngIf="sortDirection === 'desc'">arrow_drop_down</i>
<ng-content></ng-content>
